import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { modalStyles } from "../../styles/modalStyles";

const COUNTDOWN_SECONDS = 120; // 2 minutes to act before forced logout

const IdleTimeoutModal = ({ isOpen, onStayLoggedIn, onLogout }) => {
  const [secondsRemaining, setSecondsRemaining] = useState(COUNTDOWN_SECONDS);

  // Reset and start countdown whenever the modal opens
  useEffect(() => {
    if (!isOpen) {
      setSecondsRemaining(COUNTDOWN_SECONDS);
      return;
    }

    const interval = setInterval(() => {
      setSecondsRemaining((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          onLogout();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [isOpen, onLogout]);

  const minutes = Math.floor(secondsRemaining / 60);
  const seconds = secondsRemaining % 60;
  const countdownDisplay = `${minutes}:${seconds.toString().padStart(2, "0")}`;

  return (
    <Modal
      isOpen={isOpen}
      style={modalStyles}
      contentLabel="Session Timeout Warning"
      ariaHideApp={false}
    >
      <div className="modal-body">
        <div className="grid-x grid-margin-x align-middle">
          <div className="cell small-12">
            <h3>Session Timeout Warning</h3>
          </div>
        </div>
        <p>
          Your session is about to expire due to inactivity. For your security,
          you will be automatically logged out in:
        </p>
        <p
          style={{
            fontSize: "2.5rem",
            fontWeight: "bold",
            textAlign: "center",
            color: secondsRemaining <= 30 ? "red" : "inherit",
          }}
        >
          {countdownDisplay}
        </p>
        <p>
          Any unsaved progress will be lost. Click below to stay logged in.
        </p>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "1rem",
            marginTop: "1.5rem",
          }}
        >
          <button className="button secondary" onClick={onStayLoggedIn}>
            Stay Logged In
          </button>
          <button className="button" onClick={onLogout}>
            Log Out Now
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default IdleTimeoutModal;
